/* eslint-disable sort-keys-fix/sort-keys-fix */
// NOTE: name should be lowercase as lowercase serializer is used.
export const LAUNCH_ROUTE = {
  name: 'launch',
  route(): string[] {
    return ['/' + this.name];
  },
  DEFAULT: '',
  GETTING_STARTED: {
    name: 'gettingstarted',
    route(): string[] {
      return [...LAUNCH_ROUTE.route(), this.name];
    }
  },
  HOME: {
    name: 'home',
    route(): string[] {
      return [...LAUNCH_ROUTE.route(), this.name];
    }
  },
  IMPACT_CHALLENGE: {
    name: 'impactchallenge',
    route(): string[] {
      return [...LAUNCH_ROUTE.route(), this.name];
    }
  },
  PORTAL: {
    name: 'portal',
    route(): string[] {
      return [...LAUNCH_ROUTE.route(), this.name];
    },
    PORTAL_VIDEO: {
      name: 'videos/:videoId',
      route(videoId: string): string[] {
        return [...LAUNCH_ROUTE.PORTAL.route(), 'videos', videoId];
      }
    },
  },

  SCHOOL_CERTIFIED: {
    name: 'schoolcertified',
    route(): string[] {
      return [...LAUNCH_ROUTE.route(), this.name];
    }
  },
  UPCOMING_WEBINARS: {
    name: 'upcomingwebinars',
    route(): string[] {
      return [...LAUNCH_ROUTE.route(), this.name];
    }
  },
};
